var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin",attrs:{"id":"app"}},[_c('Menu'),(_vm.user.role === 'business' && _vm.user.profile.indexOf('show') > -1)?_c('ShowVideo'):_vm._e(),_c('router-view',{staticClass:"admin-router"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }